/**
 * Created by Bart Decorte
 * Date: 14/05/2020
 * Time: 19:37
 */
import Filter from './Filter';
import flatpickr from 'flatpickr/dist/flatpickr';

export default class EpochFilter extends Filter {
  constructor($root, params) {
    super($root);
    const {
      format,
      selector,
      enableTime = false,
      time24hr = true,
      minuteIncrement = 1,
      enableSeconds = true,
      noCalendar = false,
    } = params;
    this.format = format;
    this.selector = selector;
    this.enableTime = enableTime;
    this.time24hr = time24hr;
    this.minuteIncrement = minuteIncrement;
    this.enableSeconds = enableSeconds;
    this.noCalendar = noCalendar;
  }

  init() {
    super.init();
    const options = {
      allowInput: true,
      dateFormat: this.format,
      enableSeconds: this.enableSeconds,
      enableTime: this.enableTime,
      minuteIncrement: this.minuteIncrement,
      noCalendar: this.noCalendar,
      time_24hr: this.time24hr,
    };
    const element = this.valueInput().get(0);
    this.picker = flatpickr(element, options);
  }

  destroy() {
    super.destroy();
    this.picker.destroy();
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/filters/EpochFilter.js